import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
    @Input() public visible = false;
    @Input() public message = '';
    @Input() public confirmText = 'YES';
    @Input() public cancelText = 'NO';

    @Output() public confirmed = new EventEmitter<void>();
    @Output() public cancelled = new EventEmitter<void>();
    @Output() public visibleChange = new EventEmitter<boolean>();

    public onConfirm(): void {
        this.confirmed.emit();
        this.close();
    }

    public onCancel(): void {
        this.cancelled.emit();
        this.close();
    }

    private close(): void {
        this.visible = false;
        this.visibleChange.emit(false);
    }
}
